import { DatePipe } from '@angular/common';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NzDatePickerComponent } from 'ng-zorro-antd/date-picker';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { clientMaster } from 'src/app/Models/BasicForms/clientMaster';
import { project } from 'src/app/Models/BasicForms/project';
import { ApiService } from 'src/app/Service/api.service';

@Component({
  selector: 'app-project-drawer',
  templateUrl: './project-drawer.component.html',
  styleUrls: ['./project-drawer.component.css'],
  providers: [DatePipe],
})
export class ProjectDrawerComponent implements OnInit {
  @Input() drawerClose: Function;
  @Input() data: project;
  @Input() ShowLinkOrNot: boolean;

  constructor(
    public _apiService: ApiService,
    private notificationService: NzNotificationService,
    private datePipe: DatePipe
  ) {}

  ngOnInit(): void {
    this.loadAllClients();
  }

  isClientLoading = false;
  clientList = [];

  loadAllClients() {
    this.isClientLoading = true;

    this._apiService
      .getAllClients(0, 0, 'ID', 'desc', ' and IS_ACTIVE=1')
      .subscribe(
        (clientData) => {
          this.isClientLoading = false;
          this.clientList = clientData['data'];
        },
        (err) => {}
      );
  }

  close(projectMasterPage: NgForm) {
    this.drawerClose();
    this.resetDrawer(projectMasterPage);
  }

  checkProjectName(pName: string) {
    const expression = /[A-Za-z0-9]$/;
    return expression.test(String('' + pName).toLowerCase());
  }

  isSpinning = false;
  logtext: string = '';

  ischanged(type){
    if(type=='B'){
      this.data.NON_BILABLE = false
      this.data.OTHER = false
      this.data.TRAINING = false
      this.data.RESERCH_DEVLOPMENT = false
    }else if(type=='NB'){
      this.data.IS_BILLABLE = false
      this.data.OTHER = false
      this.data.TRAINING = false
      this.data.RESERCH_DEVLOPMENT = false
    }else if(type=="T"){
      this.data.IS_BILLABLE = false
      this.data.OTHER = false
      this.data.NON_BILABLE = false
      this.data.RESERCH_DEVLOPMENT = false
    }else if(type == "O"){
      this.data.IS_BILLABLE = false
      this.data.TRAINING = false
      this.data.NON_BILABLE = false
      this.data.RESERCH_DEVLOPMENT = false
    }else if(type== "RD"){
      this.data.IS_BILLABLE = false
      this.data.TRAINING = false
      this.data.NON_BILABLE = false
      this.data.OTHER = false
    }
  }

  save(addNew: boolean): void {
    var isOk = true;

    if (this.data.PROJECT_CLIENT_ID == undefined) {
      isOk = false;
      this.notificationService.error('Please Select Valid Client', '');
    }

    if (this.data.NAME != undefined) {
      if (this.data.NAME.trim() != '') {
        if (!this.checkProjectName(this.data.NAME.trim())) {
          isOk = false;
          this.notificationService.error('Please Enter Valid Project Name', '');
        }
      } else {
        isOk = false;
        this.notificationService.error('Please Enter Valid Project Name', '');
      }
    } else {
      isOk = false;
      this.notificationService.error('Please Enter Valid Project Name', '');
    }

    if (this.data.STATUS != undefined) {
      if (this.data.STATUS.trim() == '') {
        isOk = false;
        this.notificationService.error('Please Select Valid Status', '');
      }
    } else {
      isOk = false;
      this.notificationService.error('Please Select Valid Status', '');
    }

    // if (this.data.DESCRIPTION != undefined) {
    //   if (this.data.DESCRIPTION.trim() == '') {
    //     isOk = false;
    //     this.notificationService.error("Please Enter Valid Project Description", "");
    //   }
    // } else {
    //   isOk = false;
    //   this.notificationService.error("Please Enter Valid Project Description", "");
    // }

    // if (this.data.START_DATE != undefined) {
    //   if (this.data.START_DATE == null) {
    //     isOk = false;
    //     this.notificationService.error("Please Select Start Date", "");
    //   }
    // } else {
    //   isOk = false;
    //   this.notificationService.error("Please Select Start Date", "");
    // }

    // if (this.data.END_DATE != undefined) {
    //   if (this.data.END_DATE == null) {
    //     isOk = false;
    //     this.notificationService.error("Please Select End Date", "");
    //   }
    // } else {
    //   isOk = false;
    //   this.notificationService.error("Please Select End Date", "");
    // }

    // if (this.data.ESTIMATED_MANDAYS != undefined) {
    //   if (this.data.ESTIMATED_MANDAYS == null) {
    //     isOk = false;
    //     this.notificationService.error("Please Enter Estimated Mandays", "");
    //   }
    // } else {
    //   isOk = false;
    //   this.notificationService.error("Please Enter Estimated Mandays", "");
    // }

    if (this.data.SEQ_NO != undefined) {
      if (this.data.SEQ_NO == null) {
        isOk = false;
        this.notificationService.error('Please Enter Seq No.', '');
      }
    } else {
      isOk = false;
      this.notificationService.error('Please Enter Seq No.', '');
    }

    // if(this.data.ESTIMATED_HOURS != undefined) {
    //   if(this.data.ESTIMATED_HOURS== null) {
    //     isOk = false;
    //     this.notificationService.error("Please Enter Estimated Hour(s)","");
    //   }
    // }else {
    //   isOk = false;
    //   this.notificationService.error("Please Enter Estimated Hour(s)","");
    // }

    // if(this.data.ESTIMATED_MINUTES != undefined) {
    //   if(this.data.ESTIMATED_MINUTES== null) {
    //     isOk = false;
    //     this.notificationService.error("Please Enter Estimated Minute(s)","");
    //   }
    // }else {
    //   isOk = false;
    //   this.notificationService.error("Please Enter Estimated Minute(s)","");
    // }

    // if(this.data.ESTIMATED_SECONDS != undefined) {
    //   if(this.data.ESTIMATED_SECONDS== null) {
    //     isOk = false;
    //     this.notificationService.error("Please Enter Estimated Second(s)","");
    //   }
    // }else {
    //   isOk = false;
    //   this.notificationService.error("Please Enter Estimated Second(s)","");
    // }

    // if (this.data.ICON != undefined) {
    //   if (this.data.ICON.trim() == '') {
    //     isOk = false;
    //     this.notificationService.error("Please Enter Valid Icon Name", "");
    //   }
    // } else {
    //   isOk = false;
    //   this.notificationService.error("Please Enter Valid Icon Name", "");
    // }

    if (this.data.ABBREVATION != undefined) {
      if (this.data.ABBREVATION.trim() == '') {
        isOk = false;
        this.notificationService.error('Please Enter Valid Abbrevation', '');
      }
    } else {
      isOk = false;
      this.notificationService.error('Please Enter Valid Abbrevation', '');
    }

    if (isOk) {
      this.isSpinning = true;

      this.data.START_DATE = this.datePipe.transform(
        this.data.START_DATE,
        'yyyy-MM-dd'
      );
      this.data.END_DATE = this.datePipe.transform(
        this.data.END_DATE,
        'yyyy-MM-dd'
      );
      this.data.ESTIMATED_HOURS = 0;
      this.data.ESTIMATED_MINUTES = 0;
      this.data.ESTIMATED_SECONDS = 0;
      this.data.ICON = 'chrome';

      if (!this.data.ID) {
        this._apiService.createProject(this.data).subscribe(
          (successCode) => {
            if (successCode['code'] == '200') {
              this.notificationService.success(
                'Project Added Successfully',
                ''
              );

              if (!addNew) {
                this.drawerClose();
                this.isSpinning = false;

                this.logtext =
                  'Save & Close - Project Master form - SUCCESS - ' +
                  JSON.stringify(this.data) +
                  ' KEYWORD [C - Project Master ]';
                this._apiService
                  .addLog('A', this.logtext, this._apiService.emailId)
                  .subscribe((successCode) => {
                    if (successCode['code'] == '200') {
                    } else {
                    }
                  });
              } else {
                this._apiService
                  .getAllProjects(1, 1, 'SEQ_NO', 'desc', '')
                  .subscribe(
                    (data) => {
                      if (data['code'] == 200) {
                        if (data['count'] == 0) {
                          this.data.SEQ_NO = 1;
                        } else {
                          this.data.SEQ_NO = data['data'][0]['SEQ_NO'] + 1;
                        }
                        // this.drawerVisible = true;
                      }
                    },
                    (err) => {}
                  );
                this.data = new project();

                this.logtext =
                  'Save & New - Project Master form - SUCCESS - ' +
                  JSON.stringify(this.data) +
                  ' KEYWORD [C - Project Master ]';
                this._apiService
                  .addLog('A', this.logtext, this._apiService.emailId)
                  .subscribe((successCode) => {
                    if (successCode['code'] == '200') {
                    } else {
                    }
                  });
              }
              this.isSpinning = false;
            } else {
              this.notificationService.error('Failed to Add Project', '');

              this.logtext =
                'Save & Close - Project Master form - ERROR - ' +
                JSON.stringify(this.data) +
                ' KEYWORD [C - Project Master ]';
              this._apiService
                .addLog('A', this.logtext, this._apiService.emailId)
                .subscribe((successCode) => {
                  if (successCode['code'] == '200') {
                  } else {
                  }
                });
            }
          },
          (err) => {
            if (err['ok'] == false) {
              this.notificationService.error('Server Not Found', '');
            }
          }
        );
      } else {
        this._apiService.updateProject(this.data).subscribe(
          (successCode) => {
            if (successCode['code'] == '200') {
              this.notificationService.success(
                'Project Updated Successfully',
                ''
              );

              this.logtext =
                'Update & Close - Project Master form - SUCCESS - ' +
                JSON.stringify(this.data) +
                ' KEYWORD [C - Project Master ]';
              this._apiService
                .addLog('A', this.logtext, this._apiService.emailId)
                .subscribe((successCode) => {
                  if (successCode['code'] == '200') {
                  } else {
                  }
                });

              this.isSpinning = false;
              this.drawerClose();
            } else {
              this.notificationService.error('Failed to Update Project', '');

              this.isSpinning = false;

              this.logtext =
                'Update & Close - Project Master form - ERROR - ' +
                JSON.stringify(this.data) +
                ' KEYWORD [C - Project Master ]';
              this._apiService
                .addLog('A', this.logtext, this._apiService.emailId)
                .subscribe((successCode) => {
                  if (successCode['code'] == '200') {
                  } else {
                  }
                });
            }
          },
          (err) => {
            if (err['ok'] == false) {
              this.notificationService.error('Server Not Found', '');
            }
          }
        );
      }
    }
  }

  handleStartOpenChange(open: boolean): void {
    if (!open) {
      this.endDatePicker.open();
    }
  }

   //// Only number
   omit(event: any) {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  
  resetDrawer(clientMasterPage: NgForm) {
    this.data = new project();
    this.isSpinning = false;
    clientMasterPage.form.reset();
    this.ShowLinkOrNot = null;
  }

  drawerVisible = false;
  drawerTitle = '';
  clientDrawerData: clientMaster = new clientMaster();

  openClientDrawer() {
    this.drawerTitle = 'Create Client';
    this.clientDrawerData = new clientMaster();
    this.drawerVisible = true;
    this.clientDrawerData.IS_ACTIVE = true;

    this.logtext = 'ADD - Client Master form KEYWORD [A - Client Master] ';
    this._apiService
      .addLog('A', this.logtext, this._apiService.emailId)
      .subscribe((successCode) => {
        if (successCode['code'] == '200') {
        } else {
        }
      });
  }

  clientDrawerClose() {
    this.drawerVisible = false;
    this.loadAllClients();
  }

  get callBackClientkDrawerClose() {
    return this.clientDrawerClose.bind(this);
  }

  @ViewChild('endDatePicker') endDatePicker: NzDatePickerComponent;

  projectStartDateHandle(open: boolean) {
    this.data.END_DATE = null;

    if (!open) {
      this.endDatePicker.open();
      this.data.END_DATE = this.data.START_DATE;
    }
  }

  disabledProjectEndDate = (endValue: Date): boolean => {
    if (this.data.END_DATE != null) {
      if (!endValue) {
        return false;
      }

      var projectPreviousDate = new Date(this.data.START_DATE);
      projectPreviousDate.setDate(projectPreviousDate.getDate() + -1);

      return endValue <= new Date(projectPreviousDate);
    }
  };

  abbr = [];

  makeAbbrevation() {
    this.abbr = [];

    if (this.data.NAME != undefined) {
      if (this.data.NAME != null || this.data.NAME != '') {
        var abbrevation = this.data.NAME.split(' ');

        for (var i = 0; i < abbrevation.length; i++) {
          this.abbr.push(abbrevation[i].charAt(0));
        }

        var a = '';
        for (var i = 0; i < this.abbr.length; i++) {
          a = a + this.abbr[i];
        }

        this.data.ABBREVATION = '';
        this.data.ABBREVATION = a.toUpperCase();
      }
    }
  }
}
